query SubscriptionPurchases(
  $subscriptionId: ID!
  $page: Int
  $rowsPerPage: Int
) {
  productPurchases(
    subscriptionId: $subscriptionId
    page: $page
    rowsPerPage: $rowsPerPage
  ) {
    count
    nodes {
      id
      startAt
      expiredAt
      refunded
      disputed
      payment {
        id
        amount {
          value
          currency
        }
        organizationAmountInOrganizationCurrency {
          value
          currency
        }
        period
      }
    }
  }
}
